import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("iot_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const foreman = sessionStorage.getItem("iot_foreman_token");
  if (foreman) config.headers["X-Foreman-Token"] = foreman;
  return config;
});

// Auto-logout on 401 (token expired / invalid) — bounces back to /login
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    // Skip auto-redirect for the login endpoint itself (shows error toast instead)
    if (status === 401 && !/\/auth\/(login|google|unlock-foreman)/.test(url)) {
      try {
        localStorage.removeItem("iot_token");
        sessionStorage.removeItem("iot_foreman_token");
      } catch (_) {}
      if (typeof window !== "undefined" && !window.location.pathname.endsWith("/login")) {
        window.location.replace("/login?expired=1");
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || "Si è verificato un errore";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (typeof e?.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  return String(detail);
}

export default api;
